module.exports = __webpack_public_path__ + "aa056287e09dc87f605b5a15dde5e80e.png";